<!--
  ~ Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
<div class="og-container container--{{ theme }}">
  <mat-card-title class="container__title">
    {{ title }}
  </mat-card-title>

  @if (loading) {
  <div class="container__spinner">
    <mat-progress-spinner [mode]="'indeterminate'" [color]="'accent'"></mat-progress-spinner>
  </div>
  } @else { @if (!showConfirmationOverlay) {
  <div class="container__list container__list--{{ size }}">
    <mat-list class="list__container">
      @for (entry of list; track entry; let i = $index) {
      <mat-list-item
        class="container__item"
        [class.container__item--selected]="selectedIndex === i"
      >
        <div class="item__content item__content--{{ theme }}" (click)="itemClick.next(i)">
          @if (canDeleteItems) {
          <button mat-icon-button (click)="triggerConfirmationOverlay(entry)">
            <i class="material-icons">delete</i>
          </button>
          }
          <ng-container
            [ngTemplateOutlet]="itemTemplate ? itemTemplate : defaultItemTemplate"
            [ngTemplateOutletContext]="{ entry: entry }"
          ></ng-container>
        </div>
      </mat-list-item>
      } @if (showInputTemplate) {
      <mat-list-item>
        <ng-content select="[input-template]"></ng-content>
      </mat-list-item>
      }
    </mat-list>
    @if (canAddItems) {
    <div class="list__add" (click)="triggerNewEntryCreation()">
      <button mat-fab color="{{ theme }}">
        <i class="material-icons">add</i>
      </button>
    </div>
    }
  </div>
  } @if (showConfirmationOverlay) {
  <og-confirmation-panel
    [text]="constructConfirmationPanelText()"
    (cancelClicked)="cancelDeletion()"
    (confirmClicked)="confirmDeletion()"
  ></og-confirmation-panel>
  } }
</div>

<ng-template #defaultItemTemplate let-entry="entry">
  <a matLine>{{ entry }}</a>
</ng-template>
